import React from "react";
import { useNavigate } from "react-router-dom";

const MnuTools = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-slate-950 text-white">
      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 md:px-8">
        <div className="rounded-3xl border border-white/10 bg-slate-900/80 p-8 shadow-2xl backdrop-blur-md">
          <h1 className="mb-6 text-4xl font-extrabold text-emerald-300 md:text-5xl">
            Digitale Tools für deinen Weg nach Europa
          </h1>

          <p className="mb-10 max-w-3xl text-lg text-slate-200/90">
            Experts4Europe verbindet Bewerbung, Sprache, Matching und nächste Schritte in einem klaren System.
            So verstehst du schneller, wie stark dein Profil ist und was dich als Nächstes weiterbringt.
          </p>

          <section className="mb-12">
            <h2 className="mb-3 text-2xl font-bold text-white md:text-3xl">Für Fachkräfte</h2>
            <ul className="list-disc space-y-4 pl-6 text-slate-200/90">
              <li><strong>Bewerbung:</strong> Pflege CV, Skills und Referenzen in einem gemeinsamen Arbeitsraum.</li>
              <li><strong>Sprachtest:</strong> Zeige dein Niveau mit einem fokussierten B1-Testbereich.</li>
              <li><strong>Matching:</strong> Sieh neue Chancen und passende Arbeitgeber auf einen Blick.</li>
              <li><strong>Fortschritt:</strong> Verstehe, welcher Schritt dir mehr Sichtbarkeit und bessere Chancen bringt.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="mb-3 text-2xl font-bold text-white md:text-3xl">Für Arbeitgeber</h2>
            <ul className="list-disc space-y-4 pl-6 text-slate-200/90">
              <li><strong>Klare Profile:</strong> Arbeitgeber sehen keine Datenflut, sondern fokussierte Kandidaten.</li>
              <li><strong>Vergleichbare Signale:</strong> Sprache, Bewerbung und Sichtbarkeit werden nachvollziehbar dargestellt.</li>
              <li><strong>Schnellere Entscheidungen:</strong> Matching und Priorisierung helfen bei offenen Stellen in Europa.</li>
              <li><strong>Ein gemeinsames System:</strong> Bewerber und Arbeitgeber arbeiten mit derselben Plattformlogik.</li>
            </ul>
          </section>

          <section className="max-w-3xl text-lg text-slate-200/90">
            <p>
              Die Tools auf Experts4Europe sind so gebaut, dass sie Orientierung geben statt zu überfordern. Sie
              helfen dabei, Unterlagen zu verbessern, Chancen zu verstehen und Entscheidungen schneller zu treffen.
            </p>
            <p className="mt-4">
              Du brauchst keine Technikkenntnisse, sondern nur ein klares Ziel. Experts4Europe zeigt dir den nächsten
              sinnvollen Schritt.
            </p>
          </section>

          <div className="mt-12">
            <button
              onClick={() => navigate(-1)}
              className="rounded-xl bg-emerald-600/80 px-6 py-2 text-lg font-bold text-white shadow-xl transition duration-300 ease-in-out hover:bg-emerald-500/80"
            >
              Zurück
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MnuTools;
